var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,0.5c-2.3,0-4.5,0.7-6.4,1.9C3.7,3.7,2.2,5.5,1.4,7.6c-0.9,2.1-1.1,4.4-0.7,6.6s1.5,4.3,3.1,5.9s3.7,2.7,5.9,3.1 s4.5,0.2,6.6-0.7c2.1-0.9,3.9-2.3,5.2-4.2c1.3-1.9,1.9-4.1,1.9-6.4c0-3-1.2-6-3.4-8.1C18.1,1.7,15.1,0.5,12,0.5z M12,4.1 c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.5,0.5,0.7,0.8c0.1,0.3,0.2,0.7,0.1,1c-0.1,0.4-0.3,0.7-0.5,1c-0.3,0.2-0.6,0.4-0.9,0.5 c-0.3,0.1-0.7,0-1-0.1c-0.4-0.2-0.7-0.4-0.9-0.7c-0.2-0.3-0.3-0.6-0.3-1c0-0.5,0.2-0.9,0.5-1.3C11.1,4.3,11.5,4.1,12,4.1z  M13.9,18.6h-2.9c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4v-3c-0.4,0-0.7-0.2-1-0.4 c-0.3-0.3-0.4-0.6-0.4-1s0.2-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4c0.8,0,1.5,0.3,2,0.8c0.5,0.5,0.8,1.3,0.8,2v2.9c0.4,0,0.7,0.2,1,0.4 c0.3,0.3,0.4,0.6,0.4,1s-0.2,0.7-0.4,1C14.6,18.4,14.3,18.6,13.9,18.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.796a1d1b032cfb8a7958b1c8fa90af99.svg";
export { ForwardRef as ReactComponent };